import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCMAReportsSend implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "ZIDXAccountCMAReportsSendContainer";
    }
    render(){
        // console.log("cma-reports/send");
    }
}